<template>
  <div>
    <div class="page_title">对公转账记录</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div style="border-bottom: 1px solid #e8e9f0">
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo noneline"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item
              index="1"
              class="title"
            >二维码记录</el-menu-item>
            <el-menu-item
              index="2"
              class="title"
            >待核对记录</el-menu-item>
            <el-menu-item
              index="3"
              class="title"
            >已核对记录</el-menu-item>
          </el-menu>
        </div>
        <keep-alive>
          <component :is="currentComponent" />
        </keep-alive>
      </div>
    </div>
  </div>
</template>
<script>
import CodeLog from './CodeLog';
import PreCheck from './PreCheck';
import Checked from './Checked';

export default {
  data() {
    return {
      activeIndex: '1',
      active: ''
    };
  },
  computed: {
    currentComponent() {
      switch (this.active) {
        case '1':
          return CodeLog;
        case '2':
          return PreCheck;
        case '3':
          return Checked;
        default:
          return CodeLog;
      }
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      this.active = key;
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding-bottom: 20px;
}
.noneline {
  border: 0;
  padding: 0 20px;
}
.title {
  font-size: 16px;
  width: 120px;
}
</style>
